import { createSelector } from '@ngrx/store';

import { IContract } from '@models/contract.class';
import { IImmutableState } from 'src/shared/types/immutable-state';
import { AppState } from '../app-state';

type ImmutableContract = IImmutableState<IContract>;

export const selectCurrentContractFeature = (state: AppState) =>
  state.currentContract as any as ImmutableContract;

export const selectCurrentContract = createSelector(
  selectCurrentContractFeature,
  (state) => state.toJS(),
);

export const selectTotals = createSelector(
  selectCurrentContract,
  (state) => state.totals,
);

export const selectContractId = createSelector(
  selectCurrentContract,
  (state) => state.contractID,
);

export const selectIsUsa = createSelector(
  selectCurrentContract,
  (state) => state.isUsa,
);

export const selectMemberSince = createSelector(
  selectCurrentContract,
  (state) => state.memberSince,
);
